// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1Neo4jDatabaseConditionType = {
  Neo4jDatabaseOperatorTransferring: 'OperatorTransferring',
  Neo4jPrimariesScaling: 'PrimariesScaling',
  Neo4jSecondariesScaling: 'SecondariesScaling',
  Neo4jDatabaseReconciled: 'Reconciled',
  Neo4jBackendReconciled: 'BackendReconciled',
  Neo4jBackendRunning: 'BackendRunning',
  Neo4jDatabaseFaultTolerant: 'FaultTolerant',
  Neo4jDatabaseAvailable: 'Available',
  UserDatabaseReplicationReady: 'UserDatabaseReplicationReady',
  SystemDatabaseFaultTolerant: 'SystemDatabaseFaultTolerant',
  SystemDatabaseWriteAvailable: 'SystemDatabaseWriteAvailable',
  Neo4jDatabasePublicAvailable: 'PublicAvailable',
  Neo4jDatabasePrivateAvailable: 'PrivateAvailable',
  ReplicaDatabasePromotable: 'ReplicaDatabasePromotable',
  Neo4jDatabaseLoading: 'Loading',
  Neo4jDatabaseRestoring: 'Restoring',
  Neo4jDatabaseUpdating: 'Updating',
  Neo4jPrimariesUpdating: 'PrimariesUpdating',
  Neo4jSecondariesUpdating: 'SecondariesUpdating',
  Neo4jDatabaseResizing: 'Resizing',
  Neo4jDatabaseBackingUp: 'BackingUp',
  Neo4jDatabaseOutOfDisk: 'OutOfDisk',
  Neo4jDatabasePaused: 'Paused',
} as const;
export type V1Neo4jDatabaseConditionType =
  (typeof V1Neo4jDatabaseConditionType)[keyof typeof V1Neo4jDatabaseConditionType];

export function instanceOfV1Neo4jDatabaseConditionType(value: any): boolean {
  for (const key in V1Neo4jDatabaseConditionType) {
    if (
      Object.prototype.hasOwnProperty.call(V1Neo4jDatabaseConditionType, key)
    ) {
      if (
        V1Neo4jDatabaseConditionType[
          key as keyof typeof V1Neo4jDatabaseConditionType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1Neo4jDatabaseConditionTypeFromJSON(
  json: any,
): V1Neo4jDatabaseConditionType {
  return V1Neo4jDatabaseConditionTypeFromJSONTyped(json, false);
}

export function V1Neo4jDatabaseConditionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jDatabaseConditionType {
  return json as V1Neo4jDatabaseConditionType;
}

export function V1Neo4jDatabaseConditionTypeToJSON(
  value?: V1Neo4jDatabaseConditionType | null,
): any {
  return value as any;
}

export function V1Neo4jDatabaseConditionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1Neo4jDatabaseConditionType {
  return value as V1Neo4jDatabaseConditionType;
}
